module.exports = __webpack_public_path__ + "static/media/GatewayArch.b685f545.jpg";